import { render, staticRenderFns } from "./rollDetail.vue?vue&type=template&id=ebf725fe&scoped=true&"
import script from "./rollDetail.vue?vue&type=script&lang=js&"
export * from "./rollDetail.vue?vue&type=script&lang=js&"
import style0 from "../assets/csscopy/rollDetail.css?vue&type=style&index=0&id=ebf725fe&scoped=true&lang=css&"
import style1 from "./rollDetail.vue?vue&type=style&index=1&id=ebf725fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf725fe",
  null
  
)

export default component.exports